import * as Tone from 'tone';
import { putSample, deleteSample } from '../core/sample-store.js';

// Chromatic sampler — drag a single WAV/MP3 onto the lane and Tone.Sampler
// pitch-shifts it across the keyboard. Useful for piano samples, vocal chops,
// one-shot melodic loops, etc.
//
// Anchor pitch is C4. If you load a sample that's already in another key,
// you can adjust by dragging the lane's Octave selector.

export default {
    id: 'sampler',
    name: 'Sampler',
    register(ctx) {
        const channel = ctx.mixer.addChannel({ id: 'sampler', name: 'Sampler', color: '#f4d35e' });
        channel.setVolume(-6);

        let sampler = null;
        let sampleName = null;

        ctx.instruments.register({
            id: 'sampler',
            name: 'Sampler',
            kind: 'pitched',
            channelId: 'sampler',
            play(note, time, duration = '8n', velocity = 0.85) {
                if (!sampler) return;
                try { sampler.triggerAttackRelease(note, duration, time, velocity); } catch (_) {}
            },
            async loadSample(source, displayName, opts = {}) {
                const isFile = source instanceof File;
                const name = displayName ?? (isFile ? source.name : 'sample');
                let arrayBuffer;
                if (source instanceof Blob) {
                    arrayBuffer = await source.arrayBuffer();
                } else if (source instanceof ArrayBuffer) {
                    arrayBuffer = source;
                } else {
                    throw new Error('loadSample: unsupported source type');
                }
                const audioBuffer = await Tone.context.decodeAudioData(arrayBuffer.slice(0));
                if (sampler) {
                    try { sampler.disconnect(); sampler.dispose(); } catch (_) {}
                }
                sampler = new Tone.Sampler({
                    urls: { C4: new Tone.ToneAudioBuffer(audioBuffer) },
                    attack: 0.005,
                    release: 0.6,
                });
                sampler.connect(channel.input);
                await Tone.loaded();
                sampleName = name;
                if (opts.persist !== false && source instanceof Blob) {
                    try { await putSample('sampler:c4', source, name); } catch (_) {}
                }
                ctx.bus.emit('sample:loaded', { instrumentId: 'sampler', name: sampleName });
            },
            clearSample() {
                if (sampler) {
                    try { sampler.disconnect(); sampler.dispose(); } catch (_) {}
                }
                sampler = null;
                sampleName = null;
                deleteSample('sampler:c4').catch(() => {});
                ctx.bus.emit('sample:cleared', { instrumentId: 'sampler' });
            },
            getSampleName: () => sampleName,
            hasSample: () => !!sampler,
        });

        ctx.lanes.add({
            id: 'sampler',
            name: 'Sampler',
            instrumentId: 'sampler',
            kind: 'pitched',
            color: '#f4d35e',
            defaultOctave: 4,
            acceptsSample: true,
        });
    },
};
